import { render } from "./MedbisOrderPage.vue?vue&type=template&id=1bcd881e&scoped=true"
import script from "./MedbisOrderPage.vue?vue&type=script&lang=js"
export * from "./MedbisOrderPage.vue?vue&type=script&lang=js"

import "./MedbisOrderPage.vue?vue&type=style&index=0&id=1bcd881e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcd881e"]])

export default __exports__